import {saveAs} from 'file-saver';
import {getContentEscaped} from '../browser';

// tslint:disable-next-line:no-any
export function saveAsCSVFile(fileName: string, data: any[], headers: any[], delimiterCharacter = ';', displayDataAsItIs = false): void {
  const csvHeaders = headers;
  const records = data;

  // tslint:disable-next-line:no-any
  const allTableArray: any[] = [];
  if (!displayDataAsItIs) {
    // tslint:disable-next-line:no-any
    const lineArray: any[] = [];
    // tslint:disable-next-line:no-any
    csvHeaders.forEach((thisHeaderColumn: any) => {
      const titleColumn = (typeof thisHeaderColumn === 'string') ? thisHeaderColumn : thisHeaderColumn.title;
      lineArray.push(getContentEscaped(titleColumn, delimiterCharacter));
    });
    allTableArray.push(lineArray);

    records.forEach((thisRecord) => {
      // tslint:disable-next-line:no-any
      const thisLineArray: any[]  = [];
      csvHeaders.forEach((thisHeaderColumn) => {
        const idToSearch =  (typeof thisHeaderColumn === 'string') ? thisHeaderColumn : thisHeaderColumn.id;

        if (idToSearch in thisRecord) {
          const cellEscaped = getContentEscaped( thisRecord[idToSearch], delimiterCharacter);
          thisLineArray.push( cellEscaped);
        } else {
          // No content
          thisLineArray.push('');
        }
      });
      allTableArray.push(thisLineArray);
    });
  } else {
    // search for the row with the max number of items
    let maxNumItemsFound = 0;
    data.forEach((thisDataRow: string[]) => {
      if (thisDataRow.length > maxNumItemsFound) {
        maxNumItemsFound = thisDataRow.length;
      }
    });

    data.forEach((thisDataRow: string[]) => {
      const thisRowToAdd: string[] = [];
      thisDataRow.forEach((thisCell: string) => {
        const cellEscaped = getContentEscaped( thisCell, delimiterCharacter);
        thisRowToAdd.push( cellEscaped);
      });

      while (thisRowToAdd.length < maxNumItemsFound) {
        thisRowToAdd.push('');
      }

      allTableArray.push(thisRowToAdd);
    });
  }


  let allString = '';
  for (const row of allTableArray) {
    allString += row.join(delimiterCharacter) + '\r\n';
  }

  const BOM = '\uFEFF';
  const blob = new Blob( [BOM +  allString ], {type: 'text/csv;charset=utf-8'});
  saveAs(blob, fileName);
}

